import { Box, Typography, useTheme } from '@mui/material';
import { tokens } from '../../../../global/theme/tokens';

// small uppercase caption above every block inside the expanded card
export const SectionLabel = ({ children, className = '' }) => (
  <Typography
    className={`uppercase ${className}`}
    fontSize="10px"
    fontWeight={600}
    sx={{ letterSpacing: '0.09em', opacity: 0.5 }}
  >
    {children}
  </Typography>
);

// dashed placeholder row used by the file dropzone and the "add link" row
export const DashedRow = ({ children, onClick, className = '' }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  return (
    <Box
      onClick={onClick}
      className={`flex items-center justify-center gap-2 rounded-lg px-3 py-2 ${className}`}
      sx={{
        border: `1px dashed ${colors.text}30`,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'border-color 150ms, background-color 150ms',
        ':hover': onClick
          ? {
              borderColor: `${colors.info}90`,
              backgroundColor: `${colors.info}10`,
            }
          : {},
      }}
    >
      {children}
    </Box>
  );
};

export function formatFileSize(bytes) {
  if (bytes === null || bytes === undefined) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1).replace('.', ',')} MB`;
}
